import { APIFactory } from '../api/api.factory'
const ProjectsApi = APIFactory.get('projects')


export default {
    async getMyManagerProjects() {
        const { data } = await ProjectsApi.getMyManagerProjects()
        return data;
    },
    async saveProjectUsers(projectUsers) {
        if (projectUsers.userId) {
            const { data } = await ProjectsApi.saveProjectUsersAsAdmin(projectUsers);
            return data;
        }
        else {
            const { data } = await ProjectsApi.saveProjectUsers(projectUsers);
            return data;
        }
    },
    async getUserProjects(userId) {
        const { data } = await ProjectsApi.getUserProjects(userId)
        return data;
    },
    async getProjectModel(projectId) {
        const { data } = await ProjectsApi.getProjectModel(projectId)
        return data;
    },
    async getProjects() {
        const { data } = await ProjectsApi.getProjects()
        return data;
    },
    async getActiveProjects() {
        const { data } = await ProjectsApi.getActiveProjects();
        return data;
    },
    async getUserProjectsInUse(userId) {
        const { data } = await ProjectsApi.getUserProjectsInUse(userId)
        return data;
    },
    async getProject(projectId) {
        const { data } = await ProjectsApi.getProject(projectId);
        return data;
    }
}